/**
 * DOM helpers for the draggable AI Story Insight window.
 */
export function setAIInsightPanelVisible(visible, documentRef = document) {
  const panel = documentRef.getElementById('aiInsightPanel')
  if (panel) panel.style.display = visible ? 'block' : 'none'
}

export function isAIInsightPanelVisible(documentRef = document) {
  const panel = documentRef.getElementById('aiInsightPanel')
  return Boolean(panel && panel.style.display !== 'none')
}

export function setAIInsightStatus(message, documentRef = document) {
  const statusEl = documentRef.getElementById('aiInsightStatus')
  if (statusEl) statusEl.textContent = message
}

export function clampFloatingPanelPosition(panel, container, left, top) {
  const margin = 8
  const maxLeft = Math.max(
    margin,
    container.clientWidth - panel.offsetWidth - margin
  )
  const maxTop = Math.max(
    margin,
    container.clientHeight - panel.offsetHeight - margin
  )
  return {
    left: Math.max(margin, Math.min(maxLeft, left)),
    top: Math.max(margin, Math.min(maxTop, top)),
  }
}

export function makeFloatingPanelDraggable(panel, handle, container) {
  if (!panel || !handle || !container) return
  let dragState = null

  handle.addEventListener('pointerdown', event => {
    if (event.target.closest('button')) return
    const panelRect = panel.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()
    dragState = {
      startX: event.clientX,
      startY: event.clientY,
      startLeft: panelRect.left - containerRect.left,
      startTop: panelRect.top - containerRect.top,
    }
    handle.setPointerCapture(event.pointerId)
    event.preventDefault()
  })

  handle.addEventListener('pointermove', event => {
    if (!dragState) return
    const next = clampFloatingPanelPosition(
      panel,
      container,
      dragState.startLeft + event.clientX - dragState.startX,
      dragState.startTop + event.clientY - dragState.startY
    )
    panel.style.left = `${next.left}px`
    panel.style.top = `${next.top}px`
  })

  const endDrag = event => {
    dragState = null
    if (handle.hasPointerCapture(event.pointerId)) {
      handle.releasePointerCapture(event.pointerId)
    }
  }

  handle.addEventListener('pointerup', endDrag)
  handle.addEventListener('pointercancel', endDrag)
}

export function bindAIInsightPanelControls(
  callbacks = {},
  documentRef = document
) {
  const insightBtn = documentRef.getElementById('aiStoryInsightBtn')
  const insightPanel = documentRef.getElementById('aiInsightPanel')
  const insightCloseBtn = documentRef.getElementById('aiInsightCloseBtn')
  const insightRefreshBtn = documentRef.getElementById('aiInsightRefreshBtn')
  const insightDragHandle = documentRef.getElementById('aiInsightDragHandle')
  const insightList = documentRef.getElementById('aiInsightList')
  const container = documentRef.getElementById('container')

  if (container && insightPanel && insightPanel.parentNode !== container) {
    container.appendChild(insightPanel)
  }
  makeFloatingPanelDraggable(insightPanel, insightDragHandle, container)

  if (insightBtn && callbacks.onToggle) {
    insightBtn.addEventListener('click', callbacks.onToggle)
  }
  if (insightCloseBtn && callbacks.onClose) {
    insightCloseBtn.addEventListener('click', callbacks.onClose)
  }
  if (insightRefreshBtn && callbacks.onRefresh) {
    insightRefreshBtn.addEventListener('click', callbacks.onRefresh)
  }
  if (insightList && callbacks.onAction) {
    insightList.addEventListener('click', event => {
      const button = event.target.closest('button[data-action]')
      if (!button) return
      callbacks.onAction(
        button.getAttribute('data-action'),
        button.getAttribute('data-candidate-id')
      )
    })
  }
  if (insightList && callbacks.onDraftInput) {
    insightList.addEventListener('input', event => {
      const fieldEl = event.target.closest('[data-insight-field]')
      if (!fieldEl) return
      callbacks.onDraftInput(
        fieldEl.getAttribute('data-candidate-id'),
        fieldEl.getAttribute('data-insight-field'),
        fieldEl.value
      )
    })
  }
}
